import useAnalyticsContext from '@client/hooks/useAnalyticsContext';
import AnalyticsConstants from '@constants/analytics';
import { useAppSelector } from '@redux/hooks';
import { useCallback } from 'react';
import type { SeasonType } from '..';
import { EVENT_CONTACT_VENDOR_INITIATED } from '../../../../../lib/vendor-recommendation-module/utils/tracking/vrmTracking';
import { PRICING_DETAILS_PRODUCT_AREA } from './trackingConstants';

export const useTrackEstimateCTA = () => {
	const { track } = useAnalyticsContext();
	const vendorId = useAppSelector((state) => state.vendor.vendor?.id);
	const conversations = useAppSelector(
		(state) => state.messagedVendors.conversations,
	);
	const hasContactedVendor = Boolean(vendorId && conversations[vendorId]);

	return useCallback(
		(selectedSeason: SeasonType) => {
			const event = hasContactedVendor
				? AnalyticsConstants.CTA_CLICKED
				: EVENT_CONTACT_VENDOR_INITIATED;

			track({
				event,
				properties: {
					product_area: PRICING_DETAILS_PRODUCT_AREA,
					location:
						selectedSeason === 'peak' ? 'Peak season' : 'Off-peak season',
					action: 'Begin estimate flow',
				},
			});
		},
		[track, hasContactedVendor],
	);
};
